export enum ButtonGroupColour {
  slate = 'slate',
  indigo = 'indigo',
  blue = 'blue',
  orange = 'orange',
  red = 'red',
  green = 'green',
}
